import { SessionHelper } from "@/helpers/sessionHelper";

export const noSubscriptionLock = {
  mounted(el, binding) {
    const active = binding?.value == undefined ? true : binding.value;
    if (active && SessionHelper.isSubscriptionReadonly) {
      el.disabled = true;
    } else {
      el.disabled = false;
    }
  },

  updated(el, binding) {
    const active = binding?.value == undefined ? true : binding.value;
    if (active && SessionHelper.isSubscriptionReadonly) {
      el.disabled = true;
    } else {
      el.disabled = false;
    }
  }
};
